import { render, staticRenderFns } from "./IdentificationCodes.vue?vue&type=template&id=85ad72a0&"
import script from "./IdentificationCodes.vue?vue&type=script&lang=js&"
export * from "./IdentificationCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports